import { asyncComponent } from "components/AsyncComponent";
import { History } from "history";
import { useCallback } from "react";
import { Store } from "redux";
import { injectReducer } from "redux/reducers";
import { injectSaga } from "redux/sagas";
import { State } from "redux/state";

export function OrganizationRoot(history: History, store: Store<State>) {
    const load = useCallback(() => {
        return new Promise(resolve => {
            require.ensure(
                [],
                require => {

                    // Load the main component for the route
                    const componentModule = require("./main") as any;
                    const component = componentModule.default;

                    // Org Reducers & Sagas have been moved to the global reducers & sagas file
                    // because they are now accessible app-wide

                    // Then all the necessary actions and modules for Apps, Intents, & SMAPI
                    const appReducerModule = require("../App/modules") as any;
                    const appReducer = appReducerModule.appReducer;
                    injectReducer(history, store as AsyncStore<State>, { key: "app", reducer: appReducer });

                    const appSagaModule = require("../App/modules/sagas") as any;
                    const appSaga = appSagaModule.default;
                    injectSaga(store as AsyncStore<State>, appSaga);

                    resolve(component);
                },
                error => {
                    console.error(`Error loading organization route`);
                    console.error(error);
                },
                "organizations"
            );
        });
    }, [history, store]);
    return asyncComponent(load as any);
}
